import factoryStore from '../components/factory-store'

const projectTopic = {
  ...factoryStore('ProjectTopic'),
}

const projectTopicStore = {
  ...projectTopic,
}

export default projectTopicStore
